import Footer from '../../Components/Footer/footer.component'
import React,{useEffect,useState} from 'react'
import { login } from '../../api/auth'
import { loginAction } from '../../redux/auth'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { useHistory,useLocation  } from 'react-router'
import { useSnackbar } from 'react-simple-snackbar'
import { Eye, EyeOff } from "lucide-react";
import CommonHeader from '../../Components/CommonHeader/common-header.component'
import { useTranslation } from 'react-i18next'

function SignInV2() {

	const history = useHistory()
	const location = useLocation();
	const dispatch = useDispatch()
	const { register, handleSubmit,formState: { errors, isValid, isDirty } } = useForm()
	const [showPassword, setShowPassword] = useState(false);
	const [openSnackbar] = useSnackbar({
		position: 'top-center',
		style: {
			color: 'black',
			background: 'white',
			fontFamily: 'Montserrat',
		},
		closeStyle: {
			fontSize: '2rem',
			color: '#51C7F2',
		},
	})
	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	  };
    useEffect(()=>{
		const getQueryParam = (name) => {
			const urlSearchParams = new URLSearchParams(location.search);
			return urlSearchParams.get(name);
		  };
		  const email_verified = getQueryParam('email_verified');
		  const email_verifiedtransporter=getQueryParam('email-verifiedtransporter');
		  if (email_verified === 'true') {
			openSnackbar(
                 t("email_verified"),
				 120000
			)
		  }
		  if(email_verifiedtransporter==='true'){
			openSnackbar(
				t("unapproved_account"),
				120000
			)
		  }
	},[])
	
	const onSubmit = async (data) => {
		try {
			const res = await login(data.email, data.password)
			dispatch(loginAction(res.user, res.token,res.refreshToken))

			if (res.user.role === 'chauffeur') {
				history.push('/chauffeur/transports')
			}

			if (res.user.role === 'client') {
				history.push('/commandes/new')
			}
			if (res.user.role === 'commercial') {
				history.push('/commercial/client/new')
			}
			if (res.user.role === 'transporter') {
					history.push('/transports');
			}
			if ((res.user.role === 'admin') || (res.user.role === 'super admin')|| (res.user.role === 'admin distribution')||(res.user.role==='admin service après vente')) {
				history.push('/admin/clients')
			}
			if(res.user.role==='admin comptabilité'){
				history.push('/admin/plateforme/facturation')
			}
		} catch (error) {
			console.log('error',error.response?.data?.message)
			const errorMessage = error.response?.data?.message || t("login_failed");
			toast.error(errorMessage,
				{
					style: {
						fontFamily: 'Montserrat',
					},
				}
			)
		}
	}
	const {t} = useTranslation()

	return (
		<div>
			<CommonHeader />
			<div
				style={{
					height: '95vh',
					width: '100%',
					backgroundColor:'#f7f8f8',
					display: 'flex',
				    alignItems: 'center',
				    justifyContent: 'center',

				
				}}
			>
				<div
					style={{
						width: '100%',
						maxWidth: "600px",
						background:'white' ,
						borderRadius: "8px",
						padding: '2rem',
						boxShadow:"0 1px 3px rgba(0, 0, 0, 0.1)" ,
						fontFamily: 'Montserrat',

					}}
				>
					<h1 style={{
						 fontSize: "1.5rem",
						 fontWeight: 600,
						 textAlign: "center",
						 marginBottom: '2rem'
					}}>
                    {t("welcome_back")}
                    </h1>
					<form
						onSubmit={handleSubmit(onSubmit)}
						style={{							
							display: 'flex',
							flexDirection: 'column',
							gap: '1rem'

						}}
					>
						<label
							style={{
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<span
								style={{
									marginBottom: 7,
									fontSize: "14px",
									color:'#606060',
									fontWeight:500,
									lineHeight:"17px"
								}}
							>
								{t("email")}
							</span>
							<input
								{...register('email', {
									required: t("err_message1")+ t("email"),
											pattern: {
												value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
												message: t("email_err_message"),
											  },
								})}
								style={{
									padding: '1rem',
									fontFamily: 'Montserrat',
									color: '#333',
									borderRadius: "8px",
									background: 'white',
									padding: '0.75rem',
                                    border: '1px solid #D9D9D9',
                                    width: '100%',
									':focus': {
										outline: 'none',
										border: '1px solid #5BBCEA',
									  }
									
                             
								}}
								name='email'
								placeholder={t("email")}
								type='text'
							/>
							{errors.email && (
                                    <div style={{ color: 'red', marginTop: '0.5rem',fontSize:'14px' }}>
                                    {errors.email.message}
                                    </div>
                               )}
						</label>

						
						<label
							style={{
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<span
									style={{
										marginBottom: 7,
										fontSize: "14px",
										color: '#606060',
										fontWeight: 500,
										lineHeight: "17px"
									}}
								>
									{t("mdp")}
								</span>
							</div>
							<div style={{ position: 'relative' }}>
								<input
									{...register('password', {
										required: t("err_message1")+ t("mdp"),
										minLength: {
											value: 8,
											message: t("mdp_err_message"),
										},
									})}
									style={{
										fontFamily: 'Montserrat',
										color: '#333',
										borderRadius: "8px",
										background: 'white',
										padding: '0.75rem',
										border: '1px solid #D9D9D9',
										width: '100%',
										paddingRight: '40px' 
									}}
									name='password'
									placeholder={t("mdp")}
									type={showPassword ? 'text' : 'password'}
								/>
								<button
									type="button"
									onClick={togglePasswordVisibility}
									style={{
										position: 'absolute',
										right: '10px',
										top: '50%',
										transform: 'translateY(-50%)',
										background: 'none',
										border: 'none',
										cursor: 'pointer',
										color: '#606060',
										padding: '5px',
									}}
								>
									{showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
								</button>
							</div>
							{errors.password && (
								<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
									{errors.password.message}
								</div>
							)}
						</label>
						<span
							style={{
								textAlign: 'right',
								fontSize: 12,
								cursor: 'pointer',
							}}
							onClick={() => history.push('/forgot')}
						>
							{t("forgot_password")}?
						</span>
						<button
							style={{
								color: 'white',
								fontFamily: 'Montserrat',
								background: '#5BBCEA',
								border: 'none',
								padding: '1rem',
								cursor: 'pointer',
								fontWeight: 'bold',
								borderRadius: "8px",
							}}
							type='submit'
						>
							{t("login")}
						</button>
						
						<button
						 onClick={() => {
							history.push('/CreateAccount')
						 }}
							style={{
								color: '#5BBCEA',
								fontFamily: 'Montserrat',
								background:'white',
								border: '1px solid #5BBCEA',
								padding: '1rem',
								cursor: 'pointer',
								fontWeight: 'bold',
								borderRadius: "8px",
							}}
						>
                        {t("create_account")}					
                        </button>
						
					</form>
				</div>
			</div>
			<Footer />
		</div>
	)
}

export default SignInV2
